import axios from 'axios'

const {
  VUE_APP_BASE_URL,
  VUE_APP_BASE_URL_IE,
  VUE_APP_SOCKET_API,
  VUE_APP_SOLARWINDS_LOGS_URL,
  VUE_APP_SOLARWINDS_TOKEN,
  VUE_APP_SOLARWINDS_LOGGING_ENABLED
} = process.env

const siteVar = window.siteVar

// Master on/off switch for SolarWinds login logging (set per environment).
const SOLARWINDS_LOGGING_ENABLED = VUE_APP_SOLARWINDS_LOGGING_ENABLED === 'true'

// Forward guest-login request/response bodies to SolarWinds Observability's
// Logs HTTP API (https://documentation.solarwinds.com/.../configure-logs-http.htm).
// Fire-and-forget: any failure (including a CORS block, since this is sent
// directly from the browser) must never block or break the login flow, so
// errors are swallowed.
// NOTE: sending direct from the browser means VUE_APP_SOLARWINDS_TOKEN ships
// in the built bundle and is visible to end users. Rotate it if it leaks.
const logGuestLoginEvent = (payload) => {
  if (
    !SOLARWINDS_LOGGING_ENABLED ||
    !VUE_APP_SOLARWINDS_LOGS_URL ||
    !VUE_APP_SOLARWINDS_TOKEN
  ) {
    return
  }
  const logLine = JSON.stringify(Object.assign({
    service: 'tf-vue-wishlists',
    logged_at: new Date().toISOString()
  }, payload))
  return axios
    .post(VUE_APP_SOLARWINDS_LOGS_URL, logLine, {
      headers: {
        'Content-Type': 'application/octet-stream',
        Authorization: `Bearer ${VUE_APP_SOLARWINDS_TOKEN}`
      }
    })
    .catch(() => {})
}

// Postcode lookup api
const getPostcode = (postcode) => {
  return axios.get(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/address/${postcode}`)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const loginCheck = (data, event) => {
  return axios
    .post(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/wishlist/${event}/check`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const login = (data, wishlistType) => {
  return axios
    .post(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/login`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}
const guestLogin = (data, wishlistType) => {
  const url = `${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/guest/login`
  return axios
    .post(url, data)
    .then(response => {
      logGuestLoginEvent({
        event: 'guest_login',
        outcome: 'success',
        wishlist_type: wishlistType,
        url,
        request_body: data,
        response_status: response.status,
        response_body: response.data
      })
      return response
    }).catch((err) => {
      logGuestLoginEvent({
        event: 'guest_login',
        outcome: 'error',
        wishlist_type: wishlistType,
        url,
        request_body: data,
        response_status: err.response ? err.response.status : null,
        response_body: err.response ? err.response.data : (err.message || String(err))
      })
      return { error: err }
    })
}

const wishlistImage = (wishlistType, id, data) => {
  return axios
    .put(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/${id}/image`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const updateWishlist = (wishlistType, id, data) => {
  return axios
    .put(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/${id}`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}
const orderGuestcards = (id, data) => {
  return axios
    .post(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${data.wishlist_type}/giftcards/${id}/external/order`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const getContributions = (wishlistType, id) => {
  const _rnd = Math.floor((Math.random() * 100) + 1)
  return axios
    .get(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/${id}/contributions?&rnd=${_rnd}`)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const sendThankyouEmail = (wishlistType, id, data) => {
  return axios
    .post(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/${id}/contribution-thankyou`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const submitRegisterForm = (wishlistType, data) => {
  return axios
    .post(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/${wishlistType}/event/register`, data)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}

const getSFBooking = (bookNo) => {
  return axios
    .get(`${siteVar.referer === 'IE' ? VUE_APP_BASE_URL_IE : VUE_APP_BASE_URL}/api/superfacts/booking/${bookNo}}`)
    .then(response => {
      return response
    }).catch((err) => {
      return { error: err }
    })
}
const createPaymentLog = async data => {
  const result = axios.post(`${VUE_APP_SOCKET_API}/so-api/v1/pay/1/log`, data );
  return result;
};
export {
  getPostcode,
  loginCheck,
  login,
  guestLogin,
  wishlistImage,
  updateWishlist,
  orderGuestcards,
  getContributions,
  sendThankyouEmail,
  submitRegisterForm,
  getSFBooking,
  createPaymentLog
}
